import React from "react";
import PropTypes from "prop-types";

import TopPanel from "@/components/TopPanel/TopPanel";
import BreadcrumbsButtonGoBack from "@/shared/components/Breadcrumbs/BreadcrumbsButtonGoBack";
import useMediaQuery, { MEDIA_QUERIES } from "@/shared/hooks/useMediaQuery";

function BreadcrumbsHeader({
  className,
  onClickBack,
  folderType,
  title,
}) {
  const isMobileOrTablet = useMediaQuery(MEDIA_QUERIES.untilDesktopAndDesktop);

  return <BreadcrumbsButtonGoBack
    showIconBack={isMobileOrTablet}
    className={className}
    title={title}

    disabled={!isMobileOrTablet}
    folderType={folderType}
    onGoBack={onClickBack}
  />;
}

BreadcrumbsHeader.propTypes = {
  className: PropTypes.string,
  classNameTopPanel: PropTypes.string,
  title: PropTypes.string,
  realType: PropTypes.string,
  onClickBack: PropTypes.func,
};

export default BreadcrumbsHeader;
